<template>
  <v-dialog v-model="editDialog" max-width="1200px" persistent scrollable>
    <v-card v-if="selectedItem != null" style="border-radius: 10px">
      <v-card style="border-radius: 10px">
        <v-toolbar
          dark
          style="background-color: #fddf00; color: black"
          class="elevation-0"
        >
          <v-toolbar-title><h4>Edit Commission Area</h4> </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="cancel()" color="black" v-if="!isEditing"
            >close</v-icon
          >
        </v-toolbar>
        <v-card-text style="height: auto;" class="px-4 pt-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-toolbar-title><h4>Manager Commission</h4> </v-toolbar-title>
            <v-container fluid grid-list-xl>
              <v-layout wrap align-center>
                <v-flex sm6 xs12>
                  <v-autocomplete
                    outline
                    v-model="
                      selectedItem.commission_area_province
                        .commission_area_province_id
                    "
                    :items="province_list"
                    outlined
                    :loading="loadingProvince"
                    item-text="province_name_th"
                    item-value="province_id"
                    dense
                    label="Province"
                    class="mr-2"
                    @change="
                      districtList = [];
                      getDistrictList();
                    "
                  >
                    ></v-autocomplete
                  >
                </v-flex>
                <v-flex sm6 xs12>
                  <v-autocomplete
                    outline
                    v-model="
                      selectedItem.commission_area_district
                        .commission_area_district_id
                    "
                    :items="DistrcitCommissionByid"
                    outlined
                    :loading="loadingProvince"
                    item-text="district_name_th"
                    item-value="district_id"
                    dense
                    label="District"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container fluid grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.email]"
                    v-model="selectedItem.commission_area_extra_transport_price"
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Extra Transport Price(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.email]"
                    v-model="selectedItem.commission_area_gp"
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="GP(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.email]"
                    v-model="selectedItem.commission_area_fee_delivery"
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Fee Delivery(%)"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.email]"
                    v-model="selectedItem.commission_area_promotion"
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Promotion(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.email]"
                    v-model="
                      selectedItem.commission_area_fee_delivery_differentail
                    "
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Additional Fee(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.email]"
                    v-model="selectedItem.commission_area_guarantee_fee"
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Guarantee Fee(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.email]"
                    v-model="
                      selectedItem.commission_area_small_order_price
                    "
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Small Order Price(%)"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div style="border-bottom: 1.5px dotted #9E9E9E;"></div>
            </v-container>

            <v-toolbar-title><h4>Weserve Commission</h4> </v-toolbar-title>
            <v-container fluid grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="
                      selectedItem.commission_area_extra_transport_price != null
                    "
                    v-model="
                      100 - selectedItem.commission_area_extra_transport_price
                    "
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Extra Transport Price(%)"
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="selectedItem.commission_area_extra_transport_price"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Extra Transport Price(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="selectedItem.commission_area_gp != null"
                    v-model="100 - selectedItem.commission_area_gp"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="GP(%)"
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="selectedItem.commission_area_gp"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="GP(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="selectedItem.commission_area_fee_delivery != null"
                    v-model="100 - selectedItem.commission_area_fee_delivery"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Fee Delivery(%)"
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="selectedItem.commission_area_fee_delivery"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Fee Delivery(%)"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="selectedItem.commission_area_promotion != null"
                    v-model="100 - selectedItem.commission_area_promotion"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Promotion(%)"
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="selectedItem.commission_area_promotion"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Promotion(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="
                      selectedItem.commission_area_fee_delivery_differentail !=
                        null
                    "
                    v-model="
                      100 -
                        selectedItem.commission_area_fee_delivery_differentail
                    "
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Fee delivery Differentail(%)"
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="
                      selectedItem.commission_area_fee_delivery_differentail
                    "
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Fee delivery Differentail(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="selectedItem.commission_area_guarantee_fee != null"
                    v-model="100 - selectedItem.commission_area_guarantee_fee"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Guarantee Fee(%)"
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="selectedItem.commission_area_guarantee_fee"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Guarantee Fee(%)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="
                      selectedItem.commission_area_small_order_price != null
                    "
                    v-model="
                      100 - selectedItem.commission_area_small_order_price
                    "
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Small Order Price(%)"
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="selectedItem.commission_area_small_order_price"
                    disabled
                    placeholder="ระบุจำนวนที่ต้องการ"
                    label="Small Order Price(%)"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions style="padding-bottom: 30px" class="pr-4">
              <v-spacer></v-spacer>
              <v-btn
                @click="save()"
                :loading="isEditing"
                dark
                color="black"
                style="
              width: 120px;
              background: #000000 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 6px #00000029;
              border-radius: 7px;
              font-weight: bold;
              letter-spacing: 0.1rem;
            "
                >CONFIRM</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  props: ["selectedItem", "editDialog", "originalUser"],
  data() {
    return {
      rules: {
        counter: (value) => (value >= 0 && value <= 100) || "Min 0 or Max100",
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^[-+]?[0-9]+\.[0-9]+$/;
          return !pattern.test(value) || "Not Decimal";
        },
      },
      districtList: [],
      isEditing: false,
      loadingProvince: false,
      loadingDistrict: false,
      selected: [],
      valid: true,
    };
  },
  watch: {
    async editDialog() {
      if (this.editDialog == true) {
        this.loadingProvince = true;
        await this.getDistrictList();
        this.loadingProvince = false;
      }
    },
  },
  computed: {
    ...mapState({
      DistrcitCommissionByid: (state) =>
        state.fetchCommission.DistrcitCommissionByid,
    }),
    ...mapGetters({
      province_list: "fetchProvinceBack/provinceSplited",
    }),
  },
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
      fetchDistrcitCommissionByid:
        "fetchCommission/fetchDistrcitCommissionByid",
    }),
    async getDistrictList() {
      this.loadingDistrict = true;
      let selectdistrict = await this.fetchDistrcitCommissionByid({
        manager_id: this.selectedItem.commission_area_province
          .commission_area_province_id,
      });
      let select = {
        district_id: this.selectedItem.commission_area_district
          .commission_area_district_id,
        district_name_th: this.selectedItem.commission_area_district
          .commission_area_district_name,
      };
      selectdistrict.push(select);
      this.loadingDistrict = false;
      this.isLoadingDistrict = false;
    },
    cancel() {
      Object.assign(this.selectedItem, this.originalUser);
      this.$emit("setOriginal", null);
      this.$emit("setDialog", false);
    },

    async save() {
      if (this.$refs.form.validate()) {
        let payload = JSON.parse(JSON.stringify(this.selectedItem));
        this.isEditing = true;
        let _this = this;
        this.$emit("onSaved", {
          form: payload,
          done() {
            _this.isEditing = false;
            return;
          },
        });
      }
    },
  },
};
</script>

<style>
.line-changepass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-changepass:after {
  content: "Change Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
